import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { images, services } from '../../data/site';
export function ServicesSection() {
  return <section aria-labelledby="services-title" className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32" data-id="element-204" data-mp="3p5o555fxrdd2">
      <div className="grid gap-16 lg:grid-cols-12" data-id="element-205" data-mp="3u3zj9sd9ka13">
        <div className="lg:col-span-5" data-id="element-206" data-mp="3u2enjzf7ql1n">
          <h2 id="services-title" className="font-serif text-4xl font-medium leading-tight text-forest md:text-5xl" data-id="element-207" data-mp="lo62dcf0swji">
            Ce que je fais pour votre jardin
          </h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-ink-muted" data-id="element-208" data-mp="bqjjyfyiimus">
            De l’entretien courant à la création d’un massif, chaque intervention est adaptée à votre
            terrain et à la saison.
          </p>
          <div className="mt-10 grid grid-cols-2 gap-4" data-id="element-209" data-mp="2wghaihjlr7x3">
            <img src={images.hedge} alt="Taille d’une haie de buis aux cisailles" className="aspect-[4/5] w-full rounded-lg object-cover" data-id="element-210" data-mp="2wj3hog2kzles" />
            <img src={images.design} alt="Massif récemment aménagé avec graminées, lavande et allée gravillonnée" className="mt-10 aspect-[4/5] w-full rounded-lg object-cover" data-id="element-211" data-mp="47we0fpzlywl" />
          </div>
        </div>

        <div className="lg:col-span-7 lg:pt-2" data-id="element-212" data-mp="86c9l804wflm">
          <ul className="border-t border-line" data-id="element-213" data-mp="89q6w1txxym7">
            {services.map(service => <li key={service.title} className="grid gap-2 border-b border-line py-8 md:grid-cols-[1fr_1.4fr] md:gap-10" data-id="element-214" data-mp="n2bc834h5njd">
                <h3 className="font-serif text-2xl text-ink" data-id="element-215" data-mp="vwq0gv6zg8em">{service.title}</h3>
                <p className="leading-relaxed text-ink-muted" data-id="element-216" data-mp="vyss1jnsa9lg">{service.description}</p>
              </li>)}
          </ul>
          <Link to="/prestations" className="mt-8 inline-flex items-center gap-2 font-medium text-forest underline-offset-4 hover:underline" data-id="element-217" data-mp="15ucjntvbem4e">
            Détail des prestations
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-218" data-mp="3up28i0ce94iu" />
          </Link>
        </div>
      </div>
    </section>;
}